import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react'
import { emailNewsletterUnsubscribe, logDesktopAuthToken } from '../actions';
import ImportOpml from '../components/Common/ImportOpml'

export default class emailUnsubscribe extends Component {
    constructor(props) {
        super(props);
        this.state = { success: false };
    }
    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        console.dir(urlParams);
        const email = urlParams.get('email');
        // const stateParams = urlParams.get('state');
        console.log(email);
        // console.dir(stateParams);
        if (email) {
            // const stateObjArray = stateParams.split('__sep12345678__'); // JSON.parse(stateParams); 
            // console.dir(stateObjArray);
            // // console.dir(JSON.parse(JSON.stringify({provider: 'google', docId: 'ShqOGyyazbudo3Wp4w2b'})));
            // const provider = stateObjArray[0];
            // const docId = stateObjArray[1];
            // console.log(stateObjArray[0]);
            // console.log(stateObjArray[1]);
            this.setState({ success: true });
            emailNewsletterUnsubscribe(decodeURIComponent(email));
        } else {
            this.setState({ success: false });
        }
    }

    render() {
        const { success } = this.state;
        return (
            <div>
                {/* <ImportOpml isOPMLPage={true} authToken={authToken} /> */}
                <div style={{ textAlign: 'center', marginTop: '80px', padding: '4em', borderRadius: '24px', boxShadow: '0 20px 40px 0 rgba(0,11,40,.14)' }}>
                    {success && <div> <FontAwesomeIcon style={{ color: 'green', fontSize: '4em' }} icon={'check-circle'} />
                        <h3 style={{ marginTop: '1em' }}>Unsubscribed</h3>
                        <p>You have unsubscribed from this newsletter.</p>
                    </div>}
                    {!success && <div> <FontAwesomeIcon style={{ color: 'red', fontSize: '4em' }} icon={'exclamation-circle'} />
                        <h3 style={{ marginTop: '1em' }}>Error</h3>
                        <p>Please try again.</p>
                    </div>}
                </div>
            </div>
        )
    }
}
